/**
 * Тихая зелёная точка «урок уже готов» на кнопке перехода.
 *
 * Показывается только когда урок лежит в памяти и ещё свеж. Ничего не
 * сообщает вслух: это подсказка отзывчивости, а не статус, без которого
 * нельзя нажать кнопку.
 */

import { usePrefetchedLessonReady } from '../../hooks/useLessonPrefetch';

export function PrefetchDot({ userId, skillId }: { readonly userId: string; readonly skillId: string }) {
  const ready = usePrefetchedLessonReady(userId, skillId);
  if (!ready) return null;
  return (
    <span
      aria-hidden="true"
      data-testid="prefetch-ready"
      className="ml-1.5 inline-block h-2 w-2 shrink-0 rounded-full bg-correct align-middle shadow-[0_0_6px_rgb(var(--c-correct)/0.8)]"
    />
  );
}
